define([
    "./nlgToast",
    "./versionService",
    "./toastModule"
], function () {
});